import request from '@/utils/request'
import api from '../api'

export class Agent {
  search(data) {
    return request({
      url: api.agent.search,
      method: 'post',
      data
    })
  }
  subMerchantCount(data) {
    return request({
      url: api.agent.subMerchantCount,
      method: 'post',
      data
    })  
  }
  fastPaymentSearch(data) {
    return request({
      url: api.agent.fastPaymentSearch,
      method: 'post',
      data
    })  
  }
  fastPaymentDownload(data) {
    return request({
      url: api.agent.fastPaymentDownload,
      method: 'post',
      data
    })  
  }
  gatewaySearch(data) {
    return request({
      url: api.agent.gatewaySearch,
      method: 'post',
      data
    }) 
  }
  gatewayDownload(data) {
    return request({
      url: api.agent.gatewayDownload,
      method: 'post',
      data
    }) 
  }
  authenticationSearch(data) {
    return request({
      url: api.agent.authenticationSearch,
      method: 'post',
      data
    }) 
  }
  authenticationDownload(data) {
    return request({
      url: api.agent.authenticationDownload,
      method: 'post',
      data
    }) 
  }
  onBehalfSearch(data) {
    return request({
      url: api.agent.onBehalfSearch,
      method: 'post',
      data
    }) 
  }
  onBehalfDownload(data) {
    return request({
      url: api.agent.onBehalfDownload,
      method: 'post',
      data
    }) 
  }
  scanPaySearch(data) {
    return request({
      url: api.agent.scanPaySearch,
      method: 'post',
      data
    }) 
  }
  scanPayDownload(data) {
    return request({
      url: api.agent.scanPayDownload,
      method: 'post',
      data
    }) 
  }
  refundSearch(data) {
    return request({
      url: api.agent.refundSearch,
      method: 'post',
      data
    }) 
  }
  refundDownload(data) {
    return request({
      url: api.agent.refundDownload,
      method: 'post',
      data
    }) 
  }
  commitCustomSearch(data) {
    return request({
      url: api.agent.commitCustomSearch,
      method: 'post',
      data
    }) 
  }
  commitCustomDownload(data) {
    return request({
      url: api.agent.commitCustomDownload,
      method: 'post',
      data
    }) 
  }
  specialFastSearch(data) {
    return request({
      url: api.agent.specialFastSearch,
      method: 'post',
      data
    }) 
  }
  specialFastDownload(data) {
    return request({
      url: api.agent.specialFastDownload,
      method: 'post',
      data
    }) 
  }
  transactionList(data) {
    return request({
      url: api.agent.transactionList,
      method: 'post',
      data
    }) 
  }
  transactionDownload(data) {
    return request({
      url: api.agent.transactionDownload,
      method: 'post',
      data
    }) 
  }
  receiptAll(data) {
    return request({
      url: api.agent.receiptAll,
      method: 'post',
      data
    }) 
  }
  receiptExport(data) {
    return request({
      url: api.agent.receiptExport,
      method: 'post',
      data
    }) 
  }
  distributeAll(data) {
    return request({
      url: api.agent.distributeAll,
      method: 'post',
      data
    }) 
  }
  distributeExport(data) {
    return request({
      url: api.agent.distributeExport,
      method: 'post',
      data
    }) 
  }
  exportReconciliation(data) {
    return request({
      url: api.agent.exportReconciliation,
      method: 'post',
      data
    }) 
  }
  reconciliationList(data) {
    return request({
      url: api.agent.reconciliationList,
      method: 'post',
      data
    }) 
  }
  overseasReceiptAll(data) {
    return request({
      url: api.agent.overseasReceiptAll,
      method: 'post',
      data
    }) 
  }
  vaAccountExport(data) {
    return request({
      url: api.agent.vaAccountExport,
      method: 'post',
      data
    }) 
  }
  vaAccountList(data) {
    return request({
      url: api.agent.vaAccountList,
      method: 'post',
      data
    }) 
  }
  vanHistory(data) {
    return request({
      url: api.agent.vanHistory,
      method: 'post',
      data
    }) 
  }
  materialDownload(params) {
    return request({
      url: api.agent.materialDownload,
      method: 'put',
      params
    }) 
  }
  denominationlist(data) {
    return request({
      url: api.virtual.denominationlist,
      method: 'post',
      data
    })
  }
  exportDenomination(data) {
    return request({
      url: api.virtual.exportDenomination,
      method: 'post',
      data
    })
  }
}